import React from 'react';
import styles from './Login.module.css';

const WelcomeSection = () => {
    return (
        <div className={styles.leftSide}>
            <div className={styles.brandingSection}>
                <h1 className={styles.welcomeTitle}>
                    Welcome to the <span className={styles.brandName}>SclinEDC</span> Community
                </h1>

                <p className={styles.welcomeDescription}>
                    SclinEDC empowers clinical teams to design, manage, and monitor electronic
                    data capture workflows with precision and compliance. Join us to simplify
                    study setup, streamline data collection, and accelerate clinical research outcomes.
                </p>

                <div className={styles.statsSection}>
                    <div className={styles.statItem}>
                        <div className={styles.statNumber}>17,000+</div>
                        <div className={styles.statLabel}>Professionals</div>
                    </div>
                    <div className={styles.statItem}>
                        <div className={styles.statNumber}>500+</div>
                        <div className={styles.statLabel}>Studies</div>
                    </div>
                    <div className={styles.statItem}>
                        <div className={styles.statNumber}>50+</div>
                        <div className={styles.statLabel}>Countries</div>
                    </div>
                </div>

                <div className={styles.trustBadge}>
                    <p className={styles.trustText}>
                        More than 17,000 professionals trust <strong>SclinEDC</strong> — now it's your turn.
                    </p>
                </div>
            </div>
        </div>
    );
};

export default WelcomeSection;